module.exports = __webpack_public_path__ + "img/Inna-purple-logo.6ad7661d.svg";